module.exports = __webpack_public_path__ + "6867726b55f5f4751195b13a2f56dee2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Ochieng.png
// module id = R/yF
// module chunks = 0